import { JSX, useEffect } from "react";

import { Box, Theme, useTheme } from "@mui/material";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

// Import MUI components

function AuthRedirect(): JSX.Element | null {
  const theme = useTheme();
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated && !auth.isLoading) {
      navigate("/");
    }
  }, [auth.isLoading, auth.isAuthenticated, navigate]);

  if (auth.isLoading) {
    return (
      <Box sx={outerBoxStyle}>
        <Box sx={innerBoxStyle(theme)}>Signing in...</Box>
      </Box>
    );
  }

  return null;
}

const outerBoxStyle = { width: "100%", height: "calc(100vh - 108px)", display: "flex", justifyContent: "center", alignItems: "center" };
const innerBoxStyle = (theme: Theme) => ({
  width: "40%",
  height: "20%",
  border: `1px solid ${theme.palette.border.strong}`,
  borderRadius: theme.radius.sm,
  color: theme.palette.border.strong,
  backgroundColor: theme.palette.background.default,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

export default AuthRedirect;
